import React from 'react';
import MainLayoutSidebar from '../../../modules/MainLayout/MainLayoutSidebar';
import { localise } from '../../../../services/lang/lang';
import SuspenseWrapper from '../../../modules/SuspenseWrapper/SuspenseWrapper';
import InspectionDetailWrapper from './InspectionDetailWrapper';
const InspectionDetail = () => (React.createElement(MainLayoutSidebar, { sidebarSection: null, selected: "inspections" },
    React.createElement(SuspenseWrapper, { noun: localise('INSPECTION') },
        React.createElement(InspectionDetailWrapper, null))));
export default InspectionDetail;
